import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course03 from "../../../course/course-03/course";
import lesson0319 from "../../course-03/lesson-19/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "141e9ba2-b1aa-48ab-90cd-175b8fcc6e8f",
    course: {
      id: course03.id,
      slug: course03.slug as string,
      name: course03.name,
      publicId: course03.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course03, lesson0319),
    lesson: lesson0319,
  },
];

export default lessonLinks;
